 export const mapGtag = new Map<string, string>();
 mapGtag.set("localhost:4200",'GTM-NULL'); 
 mapGtag.set("ilanding.red-i.com.ar",'GTM-NULL');
 mapGtag.set("idemo.red-i.com.ar",'GTM-NULL');
 mapGtag.set("asocespaniola.com.ar",'GTM-5LNJC6V');
 mapGtag.set("amesalud.ar",'GTM-TGPD3HL');
 mapGtag.set("centromedicomartinez.com.ar",'GTM-NULL');
 mapGtag.set("espaciomo.ar",'GTM-KHL3ZB27');
 mapGtag.set("idev.red-i.kozaca.com.ar",'GTM-NULL');
 mapGtag.set("romamedicinaestetica.com.ar",'GTM-MV3ZCL5S');
 mapGtag.set("www.romamedicinaestetica.com.ar",'GTM-MV3ZCL5S');
 //mapGtag.set("172.18.0.1:4200","mo"); 
 //mapGtag.set("172.18.0.1:4200",'GTM-NULL'); 
